module.exports = __webpack_public_path__ + "static/img/eyebrows_06.f33e602.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_06.png
// module id = 6H/H
// module chunks = 0